var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PieChart',{style:({ height: _vm.height }),attrs:{"pie-chart-data":_vm.facilitiesSizePieData,"pie-chart-options":_vm.facilitiesSizePieOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }